export default __webpack_public_path__ + "static/media/notFound.3030fa85.svg";